import { cn } from "@/shared/utils/classname-merger";
import { useCallback, useState } from "react";
import { Outlet } from "react-router-dom";
import { useAppSocket } from "../../hooks/use-app-socket";
import Sidebar from "../sidebar";
import { useFrameworkWizardStore } from "@/modules/agent/components/add-new-framework/states";

const MainLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(() => {
    const local = localStorage.getItem("sidebar");
    return local ? !!local : true;
  });

  const { isWizardOpen } = useFrameworkWizardStore();

  useAppSocket();

  const toggleSidebar = useCallback(() => {
    localStorage.setItem("sidebar", JSON.stringify(!isSidebarOpen));
    setIsSidebarOpen(!isSidebarOpen);
  }, [isSidebarOpen]);

  return (
    <main className="h-screen relative w-screen flex" style={{}}>
      {!isWizardOpen && (
        <section
          className={cn(
            isSidebarOpen ? "flex-[15]" : "flex-[5]",
            "transition-all duration-300 ease-in-out",
          )}
        >
          <Sidebar isOpen={isSidebarOpen} onToggle={toggleSidebar} />
        </section>
      )}
      <section
        className={cn(
          isWizardOpen 
            ? "flex-1" 
            : isSidebarOpen 
              ? "flex-[85]" 
              : "flex-[95]",
          "overflow-hidden overflow-y-auto",
          isWizardOpen ? "p-0" : "p-4",
        )}
      >
        <div className={cn(
          "overflow-hidden border-none w-full h-full",
          !isWizardOpen && "rounded-lg"
        )}>
          <Outlet />
        </div>
      </section>
    </main>
  );
};

export default MainLayout;
